export const ifElse = <UIEvent, V>(value: any, ifTrue: UIEvent, ifFalse: V | null = null) => {
  return value ? ifTrue : ifFalse
}
